// Fetch for the "Recent capture" tab — the newest captured claims, newest-first. Re-fetches on
// tab-return (like useAssistLog) so the stream reflects captures made while the user was away.
import { useEffect, useState } from "react";
import { getMyRecentCaptures } from "../utils/api";

export default function useRecentCaptures(space = null) {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    const load = async () => {
      try {
        const data = await getMyRecentCaptures(15, space);
        if (alive) setItems(data?.items || []);
      } catch (e) {
        if (alive) setItems([]);
      } finally {
        if (alive) setLoading(false);
      }
    };
    load();
    const onFocus = () => { if (document.visibilityState !== "hidden") load(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      alive = false;
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [space]);

  return { items, loading };
}
